//

import $ from 'jquery';
import config from './../../../config';

export function get_users(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'holiday/',
			data: {
				method	: 'GET_USERS_HOLIDAY',
            }
		})
		.then(function (response) {
			dispatch({
				type 	: "GET_USERS_HOLIDAY",
				holiday	: response
			})
		})

	}
}


// Get Company
export function get_company( year){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'holiday/',
			data: {
				method	: 'GET_COMPANY_HOLIDAY',
				year: year
            }
		})
		.then(function (response) {
			dispatch({
				type 	: "GET_COMPANY_HOLIDAY",
				holiday	: response
			})
		})

	}
}



export function delete_holiday( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'holiday/',
			data: {
				method: 'DELETE_HOLIDAY',
				holiday_id: id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_HOLIDAY",
				holiday: response
			})
		})

	}
}

// Save Weekend

export function save_holiday( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'holiday/',
			data: {
				method: 'SAVE_HOLIDAY',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_HOLIDAY",
				holiday: response
			})
		})

	}
}

// Get Holidays List

export function get_holidays( id, year ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'holiday/',
			data: {
				method: 'GET_HOLIDAYS',
				id: id,
				year: year
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_HOLIDAYS",
				holiday: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/holidays/actions/holiday.action.js